import type {
  CtBadgeMeta,
  CtHandoffKey,
  CtOutcomeKey,
  CtSourceKey,
  CtSourceMeta,
} from './types';

export const GROWTH_CALL_TRACKING_META = {
  eyebrow: 'Google Ads · Call Tracking',
  titleLead: 'Call',
  titleAccent: 'tracking',
  description:
    'Every call from your Google Ads campaigns, landing pages, and SMS/Email campaigns. For general call logs and full conversation details, see AI Receptionist.',
} as const;

export const CT_SOURCE_META: Record<CtSourceKey, CtSourceMeta> = {
  ad_click_to_call: { label: 'Click-to-Call', shortLabel: 'Click-to-Call', tone: 'terra' },
  landing_page_ads: { label: 'LP (Google Ads)', shortLabel: 'Landing Page', tone: 'info' },
  landing_page_sms: { label: 'LP (SMS/Email)', shortLabel: 'SMS Landing', tone: 'iris' },
  google_ads: { label: 'Google Ads', shortLabel: 'Google Ads', tone: 'success' },
  gbp: { label: 'Google Business Profile', shortLabel: 'GBP', tone: 'info' },
  organic: { label: 'Organic Search', shortLabel: 'Organic', tone: 'iris' },
  direct: { label: 'Direct', shortLabel: 'Direct', tone: 'neutral' },
  unknown: { label: 'Unknown', shortLabel: 'Unknown', tone: 'neutral' },
};

export const CT_OUTCOME_META: Record<CtOutcomeKey, CtBadgeMeta> = {
  booked: { label: 'Booked', tone: 'success' },
  callback: { label: 'Needs Callback', tone: 'gold' },
  info_only: { label: 'Info Only', tone: 'neutral' },
  spam: { label: 'Spam / Wrong #', tone: 'neutral' },
};

export const CT_HANDOFF_META: Record<CtHandoffKey, CtBadgeMeta> = {
  ai_closed: { label: 'AI Closed', tone: 'success' },
  warm_transfer: { label: 'Warm Transfer', tone: 'info' },
  no_answer: { label: 'No Answer', tone: 'gold' },
  abandoned: { label: 'Abandoned', tone: 'neutral' },
  unknown: { label: '—', tone: 'neutral' },
};

export const CT_TABLE_FILTERS = [
  'Last 30 days',
  'Source',
  'Campaign',
  'Outcome',
  'Handoff',
] as const;
